import { render, staticRenderFns } from "./LegendPlanmode.vue?vue&type=template&id=a8b2ec44"
import script from "./LegendPlanmode.vue?vue&type=script&lang=js"
export * from "./LegendPlanmode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports